// extracted by mini-css-extract-plugin
module.exports = {"mobile-menu-container":"CollectionPage_mobile-menu-container__azZat","filter-mobile":"CollectionPage_filter-mobile__K0eEQ"};